import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AlertField from "../Components/AlertField";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";

const EditBlog = () => {
  const [alert, setAlert] = useState(null);
  const [values, setValues] = useState({});
  const [count, setCount] = useState(0);

  const [file, setFile] = useState(null);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const { id } = useParams();
  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosPrivate.get(`blog/${id}/`);
        setValues(response?.data);
      } catch (err) {
        if (!err?.response) {
          showAlert("No Server Response", "warning");
        } else {
          showAlert("Load Failed", "warning");
        }
      }
    };
    fetchData();
  }, []);

  const onChange = (e) => {
    if (e.target.name === "blog_image") {
      setFile({ blog_image: e.target.files });
    } else {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };

  useEffect(() => {
    if(values?.description !== undefined){
      setCount(values?.description.length)
    }
  }, [values])

  const onEdit = async () => {
    //checks if all the required fields are filled or not
    if (Object.keys(values).length < 3) {
      showAlert("Fill Up all the fields.", "warning");
    } else {
      const formData = new FormData();
      //appending value of appointment in formData
      for (const key in values) {
        formData.append(key, values[key]);
      }
      //file is appended after checking its existence
      if (file !== null) {
        formData.append("blog_image", file.blog_image[0]);
      } else {
        formData.delete("blog_image");
      }
      try {
        await axiosPrivate.put(`blog/${id}/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        navigate("/my/blogs", {
          state: {
            message: "Blog has been updated.",
            type: "success",
          },
        });
      } catch (err) {
        if (!err?.response) {
          showAlert("No Server Response", "warning");
        } else {
          showAlert("Update Failed", "warning");
        }
      }
    }
  };

  return (
    <div>
      <AlertField alert={alert} />
      <h2 className="text-center py-2">Edit Blog</h2>
      <div className="mx-5 py-3 bg-light">
        <div className="w-100 my-4 row justify-content-center">
          <h5 className="col-1">Title</h5>
          <input
            type="text"
            className="col-3 px-1"
            name="title"
            id="title"
            value={values?.title || ""}
            onChange={onChange}
          />
        </div>
        <div className="w-100 row justify-content-center">
          <h5 className="col-1">Category</h5>
          <select
            className="col-3"
            name="category"
            id="category"
            onChange={onChange}
            value={values?.category || ""}
          >
            <option value="select">Select Category</option>
            <option value="heart">Heart</option>
            <option value="medicine">Medicine</option>
            <option value="aayurved">Aayurved</option>
            <option value="others">Others</option>
          </select>
        </div>
        <div className="w-100 mt-4 row justify-content-center">
          <h5 className="col-1">Body</h5>
          <textarea
            name="description"
            id="description"
            className="col-3 p-1"
            rows="10"
            value={values?.description || ""}
            onChange={onChange}
          ></textarea>
        </div>
        <div className="w-100 row justify-content-center">
          <label className="col-4 text-end p-0">{count} / 4000</label>
        </div>
        <div className="w-100 my-4 row justify-content-center">
          <h5 className="col-1">Image</h5>
          <input
            className="col-3 p-0"
            type="file"
            name="blog_image"
            accept="image/png, image/jpeg"
            id="blog_image"
            onChange={onChange}
          />
          {!file && (
            <a
              href={values?.blog_image}
              className="text-center"
              target="_blank"
            >
              {values?.blog_image ? values?.blog_image.split("/").pop() : ""}
            </a>
          )}
        </div>
        <div className="text-center my-4">
          <button className="px-5 btn btn-primary" onClick={onEdit}>
            Edit
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditBlog;
